import PropTypes from 'prop-types';
import React, { useEffect } from 'react';


import { ToastContainer, toast } from 'react-toastify';

import Select from 'react-select'
import FolderViewApp from '../../FolderView/startup/FolderViewApp';
import CrmSearchInput from '../../shared/components/CrmSearchInput';
import { mergeSelectStyles } from '../../../shared/darkSelectStyles';

const selectStyles = mergeSelectStyles({
  container: (base) => ({
    ...base,
    minWidth: "258px",
    zIndex: "999"
  }),
  control: (base) => ({
    ...base,
    border: "none",
    boxShadow: 'none'
  }),
  singleValue: (base) => ({
    ...base,
    fontWeight: "bold",
    color: "var(--sl-text-brand)"
  }),
  indicatorSeparator: () => ({
    display: "none"
  }),
  indicatorsContainer: (base) => ({
    ...base,
    color: "var(--sl-text-brand)",
    fontWeight: "bold",
    fontSize: "16px",
    ':hover': {
      cursor: "pointer"
    }
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: "var(--sl-text-brand)",
    fontWeight: "bold"
  })
});

const EventsAssetCenter = ({
  csrfToken,
  currentUser,
  team,
  venueOwnerships,
  selectedVenueOwnership,
  selectedVenueOwnershipChanged,
  folder,
  folderChanged,
  folderOptions,
  searchTerm,
  searchTermChanged,
  teamRootFolder,
  teamGlobalFolder
}) => {
  return (
    <div className="position-relative">
      <ToastContainer icon={false} />
      <div className="row" style={{"marginTop": "12px"}}>
        <div className="col-12">
          <div className="assets-tab">
            <FolderViewApp csrfToken={csrfToken}
                                folder={folder}
                                teamRootFolder={teamRootFolder}
                                canSelectRootFolderAsTarget={false}
                                onFolderChanged={folderChanged}
                                noSelectionDropFolder={teamGlobalFolder}
                                onDropWithoutSelection={() => {
                                  window.location.href = "/teams/" + team.id + "/asset_center/global";
                                }}
                                currentUser={{...currentUser}}
                                confirm={{}}
                                guestTeamMemberships={[]}
                                promotersWithPermission={[]}
                                searchTerm={searchTerm}
                                showConfirmIdColumn={true}
                                headerComponent={
                                  () => (
                                    <div className="d-flex flex-column flex-md-row align-items-md-center gap-3 w-100">
                                      <Select
                                        styles={selectStyles}
                                        components={{ ClearIndicator:() => null }}
                                        options={
                                          venueOwnerships.map(function(venueOwnership){
                                            return { value: venueOwnership.id, label: venueOwnership.venueable.name }
                                          })
                                        }
                                        value={
                                          Object.keys(selectedVenueOwnership).length > 0 ? (
                                            {value: selectedVenueOwnership.id, label: selectedVenueOwnership.venueable.name}
                                          ) : ""
                                        }
                                        onChange={
                                          (selected) => {
                                            var updated = venueOwnerships.find((vo) => vo.id == selected.value);
                                            var newFolder = folderOptions.find((f) => f.foldable_id == updated.id);

                                            selectedVenueOwnershipChanged({...updated});
                                            folderChanged({...newFolder});
                                          }
                                        }
                                      />
                                      <div className="flex-grow-1">
                                        <CrmSearchInput
                                          value={searchTerm}
                                          onChange={(e) => searchTermChanged(e.target.value)}
                                          placeholder="Search events..."
                                          shortcutLabel={null}
                                        />
                                      </div>
                                    </div>
                                  )
                                }
                                team={team} />
          </div>
        </div>
      </div>
    </div>
  )
};

EventsAssetCenter.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  currentUser: PropTypes.object.isRequired,
  team: PropTypes.object.isRequired,
  venueOwnerships: PropTypes.array,
  selectedVenueOwnership: PropTypes.object,
  selectedVenueOwnershipChanged: PropTypes.func.isRequired,
  folder: PropTypes.object,
  folderChanged: PropTypes.func.isRequired,
  folderOptions: PropTypes.array,
  searchTerm: PropTypes.string,
  searchTermChanged: PropTypes.func.isRequired,
  teamRootFolder: PropTypes.object.isRequired,
  teamGlobalFolder: PropTypes.object.isRequired
};

export default EventsAssetCenter;
